import React, { Component } from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import { withRouter, Link } from "react-router-dom";
import RuleDesc from '../easyrules/RuleDesc';

const styles = theme => ({
  root: {
  }
})

class Rule458 extends Component {
    render() {
        return (
            <RuleDesc
            id="458"
            t1="頭肩頂"
            desc=""
            ruleChange={this.props.ruleChange}
            rules={this.props.rules}
        ></RuleDesc>
          );
    }
  }
  

export default withRouter(withStyles(styles)(Rule458));